import React, { useState } from 'react';
import axios from 'axios';
import { Loader2, Lock } from 'lucide-react';
import { API } from '../../config/site';
import { btn } from '../landing/shared';
import { TOKEN_KEY, errorText } from './adminApi';

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const { data } = await axios.post(`${API}/admin/login`, { password });
      sessionStorage.setItem(TOKEN_KEY, data.token);
      onLogin();
    } catch (err) {
      setError(errorText(err, 'Anmeldung fehlgeschlagen.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-paper px-5 font-sans">
      <form onSubmit={submit} className="w-full max-w-sm rounded-[24px] border border-line bg-white p-7" data-testid="admin-login-form">
        <Lock size={28} className="text-brand" aria-hidden="true" />
        <h1 className="mt-4 font-display text-2xl font-bold text-navy">Admin-Bereich</h1>
        <label htmlFor="admin-password" className="mt-6 block text-sm font-semibold text-navy">Passwort</label>
        <input id="admin-password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)}
               className="mt-1.5 block min-h-[48px] w-full rounded-2xl border border-line px-4 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/40"
               data-testid="admin-password-input" required />
        {error && <p role="alert" className="mt-3 text-sm text-nope" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className={`${btn.primary} mt-6 w-full`} data-testid="admin-login-btn">
          {busy && <Loader2 size={18} className="animate-spin" aria-hidden="true" />} Anmelden
        </button>
      </form>
    </div>
  );
};
